import { type TFunction } from 'i18next';

import { PlatformLocale } from '@/api/generated';

export const getLanguageOptions = (t: TFunction) =>
  Object.keys(PlatformLocale).map(language => ({
    label: t(`common:common.languages.${language}`),
    value: language
  }));
